import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IDuplicateActivityData, IDuplicateActivityDataState } from './DuplicatesModels'
import ApiService from '../../services/ApiService'
import { appApiEndPoints } from '../../constants/ApiEndPoints'

const initialState: IDuplicateActivityDataState = {
  duplicateActivityData: [],
  status: 'idle',
  error: null,
  tableFilters: {
    ScheduleTypeID: 1,
  },
  tablePagination: {
    PageNumber: 1,
    RecordsPerPage: 25,
  },
  tableSort: {
    SortBy: null,
    SortOrder: null,
  },
}

export const fetchData = createAsyncThunk('duplicates/fetchActivityData', async (data) => {
  const response = await ApiService.getData(appApiEndPoints.duplicateActivityDataURL, data)
  return response.data
})

export const DuplicateActivitySlice = createSlice({
  name: 'duplicateActivityData',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action?.payload
    },
    updateFilters: (state, action) => {
      state.tableFilters = action?.payload
    },
    updatePagination: (state, action) => {
      state.tablePagination = action?.payload
    },
    updateSort: (state, action) => {
      state.tableSort = action?.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchData.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.duplicateActivityData = action?.payload as IDuplicateActivityData[]
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.error?.message || 'Failed to fetch duplicate activity data'
      })
  },
})
export const { setError, updateFilters, updatePagination, updateSort } =
  DuplicateActivitySlice.actions
export default DuplicateActivitySlice.reducer
